import { AppyUser } from "../AppyUser";
import { ResponseBase } from "../base/response-base";

export class ChatForUser {
    chatId: number;
    chatMessageId: number;
    fromUserId: number;
    fromUser: AppyUser;
    fromUserFirstName: string;
    fromUserLastName: string;
    fromUserPhotoUrl: string;
    toUserId: number;
    toUser: AppyUser;
    message: string;
    read: boolean;
    sms: boolean;
    email: boolean;
    date: Date;
}

export class ChatForUserList {
    response: ResponseBase;
    chatForUserList: ChatForUser[];
}
